import React from "react";

// CSS
import "../../../css/edit-row-buttons/save-btn.css";

class SaveBtn extends React.PureComponent {
	render() {
		return (
			<button
				className={`file-save-btn` + (this.props.shown ? ` shown` : ``)}
				disabled={this.props.disabled}
				onClick={this.props.onClick}
				title="Save"
			>
				<span
					className={!!this.props.loading ? "loading icon-spinner" : "icon-checkmark"}
				/>
			</button>
		);
	}
}

export default SaveBtn;



// WEBPACK FOOTER //
// ./src/components/utils/edit-item/SaveBtn.js